import { all } from "redux-saga/effects";
import authSagas from "@pillvery/redux/auth/saga";
import usersSagas from "@pillvery/redux/users/saga";
import createUserSagas from "@pillvery/redux/users/createOrUpdateUser/saga";
import layoutSagas from "@pillvery/redux/layout/saga";
import categoriesSagas from "@pillvery/redux/categories/saga";
import subCategoriesSagas from "@pillvery/redux/subCategories/saga";
import brandsSagas from "@pillvery/redux/brands/saga";
import productsSagas from "@pillvery/redux/products/saga";
import bannersSagas from "@pillvery/redux/banners/saga";
import selectsSagas from "@pillvery/redux/selects/saga";
import promotionsSagas from "@pillvery/redux/promotions/saga";
import couponsSagas from "@pillvery/redux/coupons/saga";
import ratingsSagas from "@pillvery/redux/ratings/saga";
import ordersSagas from "@pillvery/redux/orders/saga";
import suppliersSagas from "@pillvery/redux/suppliers/saga";
import paymentsSagas from "@pillvery/redux/payments/saga";
import accountingSagas from "@pillvery/redux/accounting/saga";
import productGroupsSagas from "@pillvery/redux/productGroups/saga";
import reportsSagas from "@pillvery/redux/reports/saga";
import notificationsSagas from "@pillvery/redux/notifications/saga";
import settingsSagas from "@pillvery/redux/settings/saga";
import profileSagas from "@pillvery/redux/profile/saga";
import dashboardSagas from "@pillvery/redux/dashboard/saga";
import createOrUpdateProductGroupSagas from "@pillvery/redux/productGroups/createOrUpdateProductGroup/saga";
import createOrUpdateCategorySagas from "@pillvery/redux/categories/createOrUpdateCategory/saga";
import createOrUpdateBrandSagas from "@pillvery/redux/brands/createOrUpdateBrand/saga";
import createOrUpdateProductSagas from "@pillvery/redux/products/createOrUpdateProduct/saga";
import createOrUpdateBannerSagas from "@pillvery/redux/banners/createOrUpdateBanner/saga";
import createOrUpdateSelectSagas from "@pillvery/redux/selects/createOrUpdateSelect/saga";
import createOrUpdatePromotionSagas from "@pillvery/redux/promotions/createOrUpdatePromotion/saga";
import createOrUpdateCouponSagas from "@pillvery/redux/coupons/createOrUpdateCoupon/saga";
import giftsSagas from "@pillvery/redux/gifts/saga";
import createOrUpdateGiftSagas from "@pillvery/redux/gifts/createOrUpdateGift/saga";
import createOrUpdateBlogSagas from "@pillvery/redux/blogs/createOrUpdateBlog/saga";
import blogsSagas from "@pillvery/redux/blogs/saga";
import classificationsSagas from "@pillvery/redux/classifications/saga";
import createOrUpdateClassificationSagas from "@pillvery/redux/classifications/createOrUpdateClassification/saga";
import insuranceCompaniesSagas from "@pillvery/redux/insuranceCompanies/saga";
import createOrUpdateInsuranceCompanySagas from "@pillvery/redux/insuranceCompanies/createOrUpdateInsuranceCompany/saga";

export default function* rootSaga(getState) {
  yield all([
    subCategoriesSagas(),
    authSagas(),
    usersSagas(),
    createUserSagas(),
    layoutSagas(),
    categoriesSagas(),
    brandsSagas(),
    productsSagas(),
    bannersSagas(),
    ratingsSagas(),
    suppliersSagas(),
    paymentsSagas(),
    selectsSagas(),
    promotionsSagas(),
    couponsSagas(),
    ordersSagas(),
    accountingSagas(),
    productGroupsSagas(),
    reportsSagas(),
    settingsSagas(),
    notificationsSagas(),
    profileSagas(),
    dashboardSagas(),
    giftsSagas(),
    classificationsSagas(),
    blogsSagas(),
    createOrUpdateProductGroupSagas(),
    createOrUpdateCategorySagas(),
    createOrUpdateBrandSagas(),
    createOrUpdateProductSagas(),
    createOrUpdateBannerSagas(),
    createOrUpdateSelectSagas(),
    createOrUpdatePromotionSagas(),
    createOrUpdateCouponSagas(),
    createOrUpdateGiftSagas(),
    createOrUpdateBlogSagas(),
    createOrUpdateClassificationSagas(),
    insuranceCompaniesSagas(),
    createOrUpdateInsuranceCompanySagas(),
  ]);
}
